import { render, staticRenderFns } from "./CreativeTests.vue?vue&type=template&id=5f90148b&scoped=true"
import script from "./CreativeTests.vue?vue&type=script&lang=js"
export * from "./CreativeTests.vue?vue&type=script&lang=js"
import style0 from "./CreativeTests.vue?vue&type=style&index=0&id=5f90148b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f90148b",
  null
  
)

export default component.exports